import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Gate for routes that need a signed-in user.
 *
 * Note the `loading` check: without it, the async session lookup would make
 * every hard refresh of a protected page flash to the sign-in screen before
 * the restored session lands.
 */
export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="empty-state">Loading…</div>;
  }

  if (!session) {
    // Remember where they were headed so sign-in can send them back.
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
